











































import { Component, Prop, Vue } from "@/shared/vuepack";
import { HsabAccountNametag, HsabSsoDestination } from "@/shared/types";
import { hsabAccountIcon } from "@/shared/awesomeIconMapper";
import { formatCurrency } from "@/shared/currency.js";
import { formatMMMDateString } from "@/shared/dateString";
import NotionalAccountCardBody from "@/employee/components/landing-pages/accountSummaryDashboard/NotionalAccountCardBody.vue";
import HsaAccountCardBody from "@/employee/components/landing-pages/accountSummaryDashboard/HsaAccountCardBody.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import NotionalBalanceLineChart from "@/shared/components/charts/NotionalLineChart.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import BalanceAmount from "@/employee/components/landing-pages/accountSummaryDashboard/BalanceAmount.vue";

@Component({
  components: {
    BalanceAmount,
    NotionalBalanceLineChart,
    SsoDeepLink,
    NotionalAccountCardBody,
    HsaAccountCardBody,
  }
})
export default class NotionalAccountCard extends Vue {
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  custodianSettingsStore = useCustodianSettingsStore();

  formatMMMDateString = formatMMMDateString;
  formatCurrency = formatCurrency;

  @Prop({ required: true })
  account: HsabAccountNametag;

  @Prop()
  minHeight: string;

  @Prop({ default: false })
  showNavigationButton: boolean;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ default: false })
  hideChart: boolean;

  get showChart () {
    return this.featureFlagStore.flags.bend16025ShowHsabAccountCardChart && !this.hideChart;
  }

  get cardTitle () {
    let title = this.account.accountName;
    if (!this.account.isActive) {
      title += " (Inactive)";
    }
    return title;
  }

  get shouldNavigateNotionalsInternally () {
    return this.featureFlagStore.flags.bend15789NotionalTransactions;
  }

  get displayIconForAccount () {
    return hsabAccountIcon(this.account);
  }

  get ssoDeeplinkDestination () {
    return HsabSsoDestination.Home;
  }

  navigateToAccount () {
    this.hsabAccountsStore.navigateToAccountPage(this.account);
  }
}
